const QUOTA_KEY = 'quota';

const DATA_CREDITS_QUERY_KEY = 'data-credits';
const DATA_CREDITS_NOTIFY_KEY = 'notify-admin';

export const quotaQueryKeys = {
  all: [QUOTA_KEY] as const,

  dataCredits: () => [QUOTA_KEY, DATA_CREDITS_QUERY_KEY] as const,
  dataCreditsNotifyAdmin: () => [QUOTA_KEY, DATA_CREDITS_QUERY_KEY, DATA_CREDITS_NOTIFY_KEY] as const,

  company: () => [QUOTA_KEY, 'company'] as const,

  exportQuota: () => [QUOTA_KEY, 'export-quota'] as const,
};

export default quotaQueryKeys;
